import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { AMBER } from '../demoContent';

interface SectionHeadingProps {
  overline: string;
  heading: string;
  sub?: string;
  /** Amber overline and white text, for the navy bands. */
  onDark?: boolean;
  align?: 'left' | 'center';
}

/** One header treatment for every band, so the page reads as a single system. */
export default function SectionHeading({
  overline,
  heading,
  sub,
  onDark = false,
  align = 'center',
}: SectionHeadingProps) {
  return (
    <Box sx={{ textAlign: align, mb: { xs: 5, md: 7 } }}>
      <Typography
        component="p"
        sx={{
          fontSize: 13,
          fontWeight: 600,
          letterSpacing: 2.5,
          textTransform: 'uppercase',
          color: onDark ? AMBER.main : 'primary.main',
          mb: 1.5,
        }}
      >
        {overline}
      </Typography>
      <Typography
        variant="h3"
        component="h2"
        sx={{
          fontWeight: 700,
          letterSpacing: '-0.015em',
          color: onDark ? 'common.white' : 'text.primary',
        }}
      >
        {heading}
      </Typography>
      {sub && (
        <Typography
          variant="h6"
          component="p"
          sx={{
            mt: 2,
            fontWeight: 400,
            lineHeight: 1.6,
            maxWidth: 680,
            mx: align === 'center' ? 'auto' : 0,
            color: onDark ? alpha('#FFFFFF', 0.8) : 'text.secondary',
          }}
        >
          {sub}
        </Typography>
      )}
    </Box>
  );
}
